export const translations = {
  en: {
    brandTag: "BUILT BY FAMILY. BUILT FOR GENERATIONS.",
    langBtn: "عربي",
    nav: {
      story: "Our Story",
      family: "Our Family",
      ventures: "Our Ventures",
      values: "Our Values",
      legacy: "Legacy",
      contact: "Contact",
      admin: "Family Office",
    },
    hero: {
      eyebrow: "FAMILY  /  VENTURES  /  LEGACY",
      l1: "Built by family.",
      l2: "Built for generations.",
      text: "A family-owned investment and ventures company creating opportunities today for a stronger tomorrow.",
      cta: "Discover our story →",
      noteBig: "10",
      noteA: "children",
      noteB: "one family",
    },
    statement: {
      l1: "Ten children.",
      l2: "One shared future.",
      p: "My10Sons is built around a simple idea: family is not only where we come from — it is what we build for. We invest, create and grow with a long-term view.",
    },
    story: {
      label: "OUR STORY",
      l1: "From a family",
      l2: "to a legacy.",
      p1: "My10Sons was created to turn family values into lasting ventures. The company brings together entrepreneurship, investment and long-term stewardship under one family-owned identity.",
      p2: "We believe the strongest businesses are built with patience, integrity and a clear responsibility to the generations that follow.",
      link: "Explore our legacy →",
    },
    family: {
      label: "OUR FAMILY",
      l1: "Ten paths.",
      l2: "One foundation.",
      p: "Eight sons and two daughters — each one part of the story, and each one part of what comes next.",
      son: "Son",
      daughter: "Daughter",
    },
    ventures: {
      label: "OUR VENTURES",
      l1: "Ideas that become",
      l2: "real businesses.",
      p: "We build, invest in and support ventures that solve real problems and create durable value.",
      explore: "Explore sector →",
      items: [
        { key: "mobility", icon: "↗", title: "Mobility & Transportation", desc: "Technology and services for smarter, safer and more connected mobility." },
        { key: "technology", icon: "◈", title: "Technology & Digital", desc: "Digital platforms and intelligent solutions designed for real-world impact." },
        { key: "consumer", icon: "✦", title: "Consumer & Daily Life", desc: "Businesses that make everyday experiences easier, faster and better." },
      ],
    },
    values: {
      label: "OUR VALUES",
      h: "What we build on.",
      items: [
        { key: "family", title: "Family", desc: "Our strongest foundation." },
        { key: "integrity", title: "Integrity", desc: "Doing what is right, especially when it is difficult." },
        { key: "innovation", title: "Innovation", desc: "Always looking ahead and challenging what is possible." },
        { key: "responsibility", title: "Responsibility", desc: "Creating value with a positive and lasting impact." },
        { key: "legacy", title: "Legacy", desc: "Building today with generations in mind." },
      ],
    },
    legacy: {
      kicker: "THE LEGACY",
      l1: "What we build today",
      l2: "should matter tomorrow.",
      p: "Our ambition is not simply to own businesses. It is to create a foundation strong enough for the next generation to build upon.",
      cta: "Start a conversation →",
    },
    contact: {
      label: "CONTACT",
      l1: "Let’s build",
      l2: "what’s next.",
      p: "For partnerships, investment opportunities and ventures, get in touch with My10Sons.",
      name: "Name",
      email: "Email",
      message: "Message",
      send: "Send message →",
      sending: "Sending…",
      namePh: "Your name",
      emailPh: "you@company.com",
      msgPh: "Tell us about your opportunity",
      success: "Thank you. Your message has been received.",
      error: "Something went wrong. Please try again.",
    },
    footer: {
      rights: "My10Sons. All rights reserved.",
    },
  },
  ar: {
    brandTag: "بُنيت بالعائلة. بُنيت للأجيال.",
    langBtn: "English",
    nav: {
      story: "قصتنا",
      family: "عائلتنا",
      ventures: "مشاريعنا",
      values: "قيمنا",
      legacy: "الإرث",
      contact: "تواصل معنا",
      admin: "مكتب العائلة",
    },
    hero: {
      eyebrow: "العائلة  /  المشاريع  /  الإرث",
      l1: "نبني بعائلة.",
      l2: "نبني لأجيال.",
      text: "شركة استثمار ومشاريع مملوكة لعائلة، نصنع فيها فرص اليوم من أجل غدٍ أقوى.",
      cta: "اكتشف قصتنا ←",
      noteBig: "10",
      noteA: "أبناء",
      noteB: "عائلة واحدة",
    },
    statement: {
      l1: "عشرة أبناء.",
      l2: "مستقبل واحد مشترك.",
      p: "تقوم My10Sons على فكرة بسيطة: العائلة ليست فقط أصلنا، بل ما نبنيه من أجلها. نستثمر ونبتكر وننمو برؤية طويلة المدى.",
    },
    story: {
      label: "قصتنا",
      l1: "من عائلة",
      l2: "إلى إرث.",
      p1: "تأسست My10Sons لتحويل قيم العائلة إلى مشاريع دائمة. تجمع الشركة بين ريادة الأعمال والاستثمار والإشراف طويل الأمد تحت هوية واحدة مملوكة للعائلة.",
      p2: "نؤمن بأن أقوى الشركات تُبنى بالصبر والنزاهة ومسؤولية واضحة تجاه الأجيال القادمة.",
      link: "استكشف إرثنا ←",
    },
    family: {
      label: "عائلتنا",
      l1: "عشرة مسارات.",
      l2: "أساس واحد.",
      p: "ثمانية أبناء وابنتان — كل واحد منهم جزء من القصة، وجزء مما هو قادم.",
      son: "الابن",
      daughter: "الابنة",
    },
    ventures: {
      label: "مشاريعنا",
      l1: "أفكار تصبح",
      l2: "أعمالاً حقيقية.",
      p: "نبني ونستثمر وندعم مشاريع تحل مشكلات حقيقية وتصنع قيمة دائمة.",
      explore: "استكشف القطاع ←",
      items: [
        { key: "mobility", icon: "↗", title: "التنقل والمواصلات", desc: "تقنيات وخدمات لتنقل أذكى وأكثر أماناً واتصالاً." },
        { key: "technology", icon: "◈", title: "التقنية والحلول الرقمية", desc: "منصات رقمية وحلول ذكية مصممة لتأثير واقعي ملموس." },
        { key: "consumer", icon: "✦", title: "المستهلك والحياة اليومية", desc: "أعمال تجعل التجارب اليومية أسهل وأسرع وأفضل." },
      ],
    },
    values: {
      label: "قيمنا",
      h: "ما نبني عليه.",
      items: [
        { key: "family", title: "العائلة", desc: "أساسنا الأقوى." },
        { key: "integrity", title: "النزاهة", desc: "نفعل ما هو صحيح، خاصة عندما يكون صعباً." },
        { key: "innovation", title: "الابتكار", desc: "نتطلع دائماً للأمام ونتحدى الممكن." },
        { key: "responsibility", title: "المسؤولية", desc: "نصنع قيمة بأثر إيجابي ودائم." },
        { key: "legacy", title: "الإرث", desc: "نبني اليوم ونحن نفكر في الأجيال." },
      ],
    },
    legacy: {
      kicker: "الإرث",
      l1: "ما نبنيه اليوم",
      l2: "يجب أن يهمّ غداً.",
      p: "طموحنا ليس مجرد امتلاك الأعمال، بل بناء أساس قوي بما يكفي ليبني عليه الجيل القادم.",
      cta: "ابدأ المحادثة ←",
    },
    contact: {
      label: "تواصل",
      l1: "لنبنِ معاً",
      l2: "ما هو قادم.",
      p: "للشراكات وفرص الاستثمار والمشاريع، تواصل مع My10Sons.",
      name: "الاسم",
      email: "البريد الإلكتروني",
      message: "الرسالة",
      send: "إرسال الرسالة ←",
      sending: "جارٍ الإرسال…",
      namePh: "اسمك",
      emailPh: "you@company.com",
      msgPh: "حدثنا عن فرصتك",
      success: "شكراً لك. تم استلام رسالتك.",
      error: "حدث خطأ ما. يرجى المحاولة مرة أخرى.",
    },
    footer: {
      rights: "My10Sons. جميع الحقوق محفوظة.",
    },
  },
};

export const familyMembers = [
  { slug: "son-1", order: "01", kind: "boy", name: { en: "Mussaad", ar: "مسعد" } },
  { slug: "son-2", order: "02", kind: "boy", name: { en: "Abdulhadi", ar: "عبدالهادي" } },
  { slug: "son-3", order: "03", kind: "boy", name: { en: "Mohammad", ar: "محمد" } },
  { slug: "son-4", order: "04", kind: "boy", name: { en: "Talal", ar: "طلال" } },
  { slug: "son-5", order: "05", kind: "boy", name: { en: "Ibraheem", ar: "إبراهيم" } },
  { slug: "son-6", order: "06", kind: "boy", name: { en: "Yousef", ar: "يوسف" } },
  { slug: "daughter-1", order: "07", kind: "girl", name: { en: "Reema", ar: "ريما" } },
  { slug: "son-7", order: "08", kind: "boy", name: { en: "Sultan", ar: "سلطان" } },
  { slug: "daughter-2", order: "09", kind: "girl", name: { en: "Shahad", ar: "شهد" } },
  { slug: "son-8", order: "10", kind: "boy", name: { en: "Abdulaziz", ar: "عبدالعزيز" } },
];
